export default __webpack_public_path__ + "static/media/jee_mock_legacy_web.f9d21c13.webp";